import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';
import img from './administrator.png';
import arrowUpImg from '../../arrow-up.png';
import returnImg from '../../return.png';

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleAdminClick = () => {
    if (location.pathname === '/Admin') {
      navigate('/');
    } else {
      navigate('/Admin');
    }
  };

  return (
    <footer id='footer' className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          🧠 RapidMind
        </div>

        <nav className="footer-nav">
          <a href="/about">À propos</a>
          <a href="/pricing">Tarifs</a>
          <a href="/contact">Contact</a>
          <a href="/terms">Conditions</a> 
        </nav>
        <img
          id='arrow-up-logo'
          src={arrowUpImg}
          alt='arrow-up-logo'
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{cursor:'pointer',position:'absolute',top:'10px',left:'3px',width:'30px',height:'30px',objectFit:'contain'}}
        />
        <img
          id='return-logo'
          src={returnImg}
          alt='return-logo'
          onClick={() => navigate('/home')}
          style={{ cursor: 'pointer', position: 'absolute', bottom: '10px', left: '50px', width: '30px', height: '30px', objectFit: 'contain' }}
        />
        <img
          id='administator-logo'
          src={img}
          alt='administator-logo'
          onClick={handleAdminClick}
          style={{ cursor: 'pointer' }}
        />

              <p>Helping creators grow through high-performance AI applications.</p>

        <div className="footer-copy">
          © {new Date().getFullYear()} RapidMind. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
